import { Injectable } from "@angular/core";
import { Observable, catchError, map, retry } from "rxjs";

//models
import { environment } from "src/environments/environment";

//services
import { ApiEnum, HttpDataService } from "./http-data.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class ImportService {
	constructor(private readonly httpDataService: HttpDataService) {}

	uploadFinancialData(file: File): Observable<any> {
		return this.httpDataService
			.postFile$<string>(
				ApiEnum.API_ROOT,
				environment.endpoint.contratos.uploadFinancialData,
				file,
				{
					responseType: "text" as "json",
				}
			)
			.pipe(
				map((fileResult) => {
					return fileResult;
				}),
				retry(3),
				catchError(
					this.httpDataService.handleError<string>(
						"uploadFinancialData"
					)
				)
			);
	}

	uploadUsers(file: File): Observable<any> {
		return this.httpDataService
			.postFile$<string>(
				ApiEnum.API_ROOT,
				environment.endpoint.centros.uploadUsers,
				file
			)
			.pipe(
				map((fileResult) => {
					return fileResult;
				}),
				catchError(
					this.httpDataService.handleError<string>("uploadUsers")
				)
			);
	}
}
